export const setNestedValue = (base, fieldPath, value) => {
    if (!base || typeof base !== 'object') {
        return setNestedValue({}, fieldPath, value);
    }
    if (fieldPath.indexOf('.') === -1) {
        return { ...base, [fieldPath]: value };
    }
    const fields = fieldPath.split('.');
    return {
        ...base,
        [fields[0]]: setNestedValue(base[fields[0]], fields.splice(1).join('.'), value),
    };
};
export const getDeepOr = (defaultValue, base, field, ...fields) => {
    const deep = getDeep(base, field, ...fields);
    return deep != null ? deep : defaultValue;
};
export const actOnData = (data, func) => (data != null ? func(data) : null);
export const getDeep = (base, field, ...fields) => {
    if (field == null) {
        return base;
    }
    if (!base || typeof base !== 'object') {
        return null;
    }
    if (typeof field === 'string' && field.indexOf('.') !== -1) {
        //@ts-ignore
        return getDeep(base[field.split('.')[0]], ...field.split('.').splice(1));
    }
    return getDeep(base[field], fields[0], ...fields.splice(1));
};
const stringOperation = func => arg => {
    if (arg == null) {
        return '';
    }
    if (typeof arg === 'string') {
        return func(arg);
    }
    if (Array.isArray(arg)) {
        return arg.map(func);
    }
    if (typeof arg === 'object') {
        const temp = {};
        Object.keys(arg).forEach(k => {
            temp[k] = func(arg[k]);
        });
        return temp;
    }
    return `${arg}`;
};
export const capitalizeFirstLetter = stringOperation(arg => arg.charAt(0).toUpperCase() + arg.substring(1));
export const nonBreakingSpace = stringOperation(arg => arg.replace(/ /g, '\u00A0'));
